import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCopyToClipboard } from 'react-use';
import {
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Box,
} from '@mui/material';
// import { useTranslation } from 'react-i18next';

type ResultProps = {
  readonly uuid: string;
  readonly password: string;
  readonly prefix: 's' | 'f';
  readonly customPassword?: boolean;
};

export default function Result({ uuid, password, prefix, customPassword }: ResultProps) {
  const base =
    (process.env.PUBLIC_URL ||
      `${window.location.protocol}//${window.location.host}`) + `/#/${prefix}`;
  const short = `${base}/${uuid}`;
  const full = `${short}/${password}`;
  // const { t } = useTranslation();

  return (
    <Box>
      {/* <Typography variant="h4">{t('result.title')}</Typography> */}
      <Typography sx={{mb: '1rem', ml: '0.6rem'}}>
        Remember that secrets can only be downloaded once. So do not open the link yourself.
      </Typography>
      <TableContainer>
        <Table>          
          <TableBody>
            <Row label='One-click link' value={full} />
          </TableBody>
        </Table>
      </TableContainer>
      <Typography sx={{mt: '2rem', ml: '0.6rem'}}>
        The cautious can send the link and encryption key in separate communication channels.
      </Typography>
      <TableContainer>        
        <Table>          
          <TableBody>
            <Row label='Encrypted link' value={short} />
            <Row label='Decryption key' value={password} />
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
    // <Box>
    //   {/* <Typography variant="h4">{t('result.title')}</Typography> */}
    //   <Typography>
    //     Remember that secrets can only be downloaded once if not set otherwise. So do not open the link yourself. 
    //     <br />
    //     The cautious should send the decryption key in a separate communication channel.
    //   </Typography>
    //   <TableContainer>
    //     <Table>
    //       <TableBody>
    //         {!customPassword && (
    //           <Row label='One-click link' value={full} />
    //         )}
    //         <Row label='Short link' value={short} />
    //         <Row label='Decryption Key' value={password} />
    //       </TableBody>
    //     </Table>
    //   </TableContainer>
    // </Box>
  );
};

type RowProps = {
  readonly label: string;
  readonly value: string;
};

const Row = ({ label, value }: RowProps) => {
  const [copy, copyToClipboard] = useCopyToClipboard();
  return (
    <TableRow key={label}>
      <TableCell width="15">
        <Button
          color={copy.error ? 'secondary' : 'primary'}
          variant="contained"
          onClick={() => copyToClipboard(value)}
        >
          <FontAwesomeIcon icon={faCopy} />
        </Button>
      </TableCell>
      <TableCell width="100" padding="none">
        <strong>{label}</strong>
      </TableCell>
      <TableCell>{value}</TableCell>
    </TableRow>
  );
};
